module.exports = __webpack_public_path__ + "static/img/Triangle_Tool.6576aa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tools/Triangle_Tool.png
// module id = 1107
// module chunks = 21